import Http from 'axios';

export default {
    namespaced: true,

    state: {
        posts: [],
    },

    getters: {
        getPostById: (state) => (id) => {
            return state.posts.find(post => post.id == id) || null;
        },

        getFilteredPosts: (state) => (filter = null, category = null) => {
            let posts = state.posts;

            if (filter == 'featured') {
                posts = state.posts.filter(post => post.is_featured);
            }

            if (category) {
                posts = posts.filter(post => {
                    return post.categories.find(cat => cat.id == category.id) || false;
                });
            }

            return posts;
        },

        featuredPosts(state) {
            return state.posts.filter(post => post.is_featured);
        }
    },

    mutations: {
        setPosts(state, posts) {
            state.posts = posts;
        },
    },

    actions: {
        loadPosts({ commit }) {
            return Http.get('/api/blog/post').then(res => {
                commit('setPosts', res.data);
            });
        },
    }
}


// WEBPACK FOOTER //
// ../default-js/js/store/modules/blog.js